import { FiberRefsSym as FiberRefsSym$1, delete_ as delete_$1, fiberRefs as fiberRefs$1, forkAs as forkAs$1, get as get$1, getOrDefault as getOrDefault$1, joinAs as joinAs$1, setAll as setAll$1, updatedAs as updatedAs$1, unsafeMake as unsafeMake$1, empty as empty$1 } from '../../internal/fiberRefs.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const FiberRefsSym = FiberRefsSym$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * `FiberRefs` is a data type that represents a collection of `FiberRef` values.
 *
 * This allows safely propagating `FiberRef` values across fiber boundaries, for
 * example between an asynchronous producer and consumer.
 *
 * @since 2.0.0
 * @category models
 */

const delete_ = delete_$1;

/**
 * Returns a set of each `FiberRef` in this collection.
 *
 * @since 2.0.0
 * @category getters
 */
const fiberRefs = fiberRefs$1;

/**
 * Forks this collection of fiber refs as the specified child fiber id. This
 * will potentially modify the value of the fiber refs, as determined by the
 * individual fiber refs that make up the collection.
 *
 * @since 2.0.0
 * @category utils
 */
const forkAs = forkAs$1;

/**
 * Gets the value of the specified `FiberRef` in this collection of `FiberRef`
 * values if it exists or `None` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const get = get$1;

/**
 * Gets the value of the specified `FiberRef` in this collection of `FiberRef`
 * values if it exists or the `initial` value of the `FiberRef` otherwise.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrDefault = getOrDefault$1;

/**
 * Joins this collection of fiber refs to the specified collection, as the
 * specified fiber id. This will perform diffing and merging to ensure
 * preservation of maximum information from both child and parent refs.
 *
 * @since 2.0.0
 * @category utils
 */
const joinAs = joinAs$1;

/**
 * Set each ref to either its value or its default.
 *
 * @since 2.0.0
 * @category utils
 */
const setAll = setAll$1;

/**
 * Updates the value of the specified `FiberRef` using the provided `FiberId`
 *
 * @since 2.0.0
 * @category utils
 */
const updatedAs = updatedAs$1;

/**
 * Note: it will not copy the provided Map, make sure to provide a fresh one.
 *
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = unsafeMake$1;

/**
 * The empty collection of `FiberRef` values.
 *
 * @category constructors
 * @since 2.0.0
 */
const empty = empty$1;

export { FiberRefsSym, delete_ as delete, empty, fiberRefs, forkAs, get, getOrDefault, joinAs, setAll, unsafeMake, updatedAs };
